import React from 'react';
import './Skeleton.css';

export interface SkeletonProps {
  /** Skeleton variant */
  variant?: 'text' | 'circular' | 'rectangular';
  /** Width (CSS value or number in pixels) */
  width?: string | number;
  /** Height (CSS value or number in pixels) */
  height?: string | number;
  /** Additional CSS classes */
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'text',
  width,
  height,
  className = '',
}) => {
  const classNames = [
    'ui-skeleton',
    `ui-skeleton--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style: React.CSSProperties = {};

  if (width) {
    style.width = typeof width === 'number' ? `${width}px` : width;
  }

  if (height) {
    style.height = typeof height === 'number' ? `${height}px` : height;
  }

  return <div className={classNames} style={style} aria-busy="true" aria-live="polite" />;
};

Skeleton.displayName = 'Skeleton';
